import { useField } from 'vee-validate'

export function useBaseInput() {
  function allowNumber(type: string, event: KeyboardEvent, isFloat?: boolean): void {
    const enterKeycode: number = 13
    const deleteKeycode: number = 46
    if (
      Number.isNaN(Number(event.key)) &&
      type === 'tel' &&
      event.keyCode !== enterKeycode &&
      isFloat &&
      event.keyCode !== deleteKeycode
    ) {
      event.preventDefault()
    }
  }

  return {
    useField,
    allowNumber
  }
}
